export default __webpack_public_path__ + "img/olivertree_attic.d0e86d454be47be567f7b164c487bbbd.png";